import { render, staticRenderFns } from "./ProductOrders.vue?vue&type=template&id=25b85648"
import script from "./ProductOrders.vue?vue&type=script&lang=js"
export * from "./ProductOrders.vue?vue&type=script&lang=js"
import style0 from "./ProductOrders.vue?vue&type=style&index=0&id=25b85648&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports